function getQuantityItem(item, folderId) {
    if (!item.stock || !item.stock.length) {
        return 0;
    }

    const stock = item.stock.find((stock) => stock.folder_id === folderId);
    return stock ? stock.quantity : 0;
}

export { getQuantityItem };
